import { useLogger } from "@agportal/logger";
import { createRestClient } from "@dmvs/client";
import { strict as assert } from "assert";
import { isEmpty, isNil } from "lodash-es";

/**
 * Service to offer access methods for subjects' users.
 */
export default class UzivatelPovereniService {
    constructor(url) {
        assert(url, "url has to be specified");

        this.logger = useLogger();
        this.rest = createRestClient({
            baseURL: url,
        });
    }

    async ctiInformaceOPovereni(token) {
        if (!isNil(token)) {
            const { data } = await this.rest.get("/pozadavky/info", {
                params: {
                    token,
                },
            });

            this.logger.debug(
                "UzivatelPovereniService.ctiInformaceOPovereni for token {0} returns {1}",
                token,
                data
            );

            return data;
        }
    }

    async odesliVyjadreniKPovereni(vyjadreni) {
        if (!isEmpty(vyjadreni)) {
            const { data } = await this.rest.post("/pozadavky/vyjadreni", vyjadreni);

            this.logger.debug(
                "UzivatelPovereniService.odesliVyjadreniKPovereni for statement {0} returns {1}",
                vyjadreni,
                data
            );

            return data;
        }
    }
}
